import { UploadFileAPI } from '../../../api/bussched/UploadFileAPI';

export class UploadCommand {
    constructor() {
        this.uploadFileApi = new UploadFileAPI();
    }

    uploadFont(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);

        const apiResult = this.uploadFileApi.uploadFont(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Tipo de letra carregado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a carregar o tipo de letra");
            }
        });
    }

    uploadLayout(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);

        const apiResult = this.uploadFileApi.uploadLayout(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Layout carregado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a carregar o Layout");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/UploadCommand.js